/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConflictResponse,
  ForbiddenResponse,
  ListRecordingsParams,
  NotFoundResponse,
  Problem,
  RecordingPage,
  SignedURL,
  UnauthorizedResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListRecordingsUrl = (params?: ListRecordingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/recordings?${stringifiedParams}` : `/v1/recordings`
}

/**
 * do bucket de gravacoes, que a §15.3 mantem como provisionamento manual.
 *
 * Aluno alcanca automaticamente as proprias aulas, sem liberacao do admin.
 * Professor, somente as dele. Super Admin, todas, com reproducao auditada.
 * Suporte tecnico nao alcanca nenhuma.
 * @summary Lista gravacoes acessiveis ao solicitante
 */
export const listRecordings = async (params?: ListRecordingsParams, options?: Parameters<typeof apiFetch>[1]): Promise<RecordingPage> => {

  return apiFetch<RecordingPage>(getListRecordingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecordingsQueryKey = (params?: ListRecordingsParams,) => {
    return [
    `/v1/recordings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRecordingsQueryOptions = <TData = Awaited<ReturnType<typeof listRecordings>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListRecordingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecordingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecordings>>> = ({ signal }) => listRecordings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecordingsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecordings>>>
export type ListRecordingsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListRecordings<TData = Awaited<ReturnType<typeof listRecordings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListRecordingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecordings>>,
          TError,
          Awaited<ReturnType<typeof listRecordings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecordings<TData = Awaited<ReturnType<typeof listRecordings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListRecordingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecordings>>,
          TError,
          Awaited<ReturnType<typeof listRecordings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecordings<TData = Awaited<ReturnType<typeof listRecordings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListRecordingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista gravacoes acessiveis ao solicitante
 */

export function useListRecordings<TData = Awaited<ReturnType<typeof listRecordings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListRecordingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecordingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateRecordingPlaybackURLUrl = (recordingId: string,) => {




  return `/v1/recordings/${recordingId}/playback-url`
}

/**
 * do bucket e do CloudFront de gravacoes (§15.3).
 *
 * Reproducao nunca sai direto do bucket. Todo acesso gera registro.
 * @summary Emite URL assinada de curta duracao para reproducao
 */
export const createRecordingPlaybackURL = async (recordingId: string, options?: Parameters<typeof apiFetch>[1]): Promise<SignedURL> => {

  return apiFetch<SignedURL>(getCreateRecordingPlaybackURLUrl(recordingId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateRecordingPlaybackURLMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecordingPlaybackURL>>, TError,{recordingId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRecordingPlaybackURL>>, TError,{recordingId: string}, TContext> => {

const mutationKey = ['createRecordingPlaybackURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRecordingPlaybackURL>>, {recordingId: string}> = (props) => {
          const {recordingId} = props ?? {};

          return  createRecordingPlaybackURL(recordingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRecordingPlaybackURLMutationResult = NonNullable<Awaited<ReturnType<typeof createRecordingPlaybackURL>>>

    export type CreateRecordingPlaybackURLMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Emite URL assinada de curta duracao para reproducao
 */
export const useCreateRecordingPlaybackURL = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecordingPlaybackURL>>, TError,{recordingId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRecordingPlaybackURL>>,
        TError,
        {recordingId: string},
        TContext
      > => {
      return useMutation(getCreateRecordingPlaybackURLMutationOptions(options), queryClient);
    }
    export const getCreateRecordingDownloadURLUrl = (recordingId: string,) => {




  return `/v1/recordings/${recordingId}/download-url`
}

/**
 * **Download e permitido em aula individual e recusado com 403 em aula em
 * dupla.** A razao e juridica e nao de preferencia: a LGPD da direito de
 * revogar consentimento e pedir eliminacao, e um arquivo ja baixado por um
 * colega torna essa obrigacao incumprivel. Em dupla existe apenas
 * reproducao por URL assinada de curta duracao.
 * @summary Emite URL assinada para download da gravacao
 */
export const createRecordingDownloadURL = async (recordingId: string, options?: Parameters<typeof apiFetch>[1]): Promise<SignedURL> => {

  return apiFetch<SignedURL>(getCreateRecordingDownloadURLUrl(recordingId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateRecordingDownloadURLMutationOptions = <TError = UnauthorizedResponse | Problem | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecordingDownloadURL>>, TError,{recordingId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRecordingDownloadURL>>, TError,{recordingId: string}, TContext> => {

const mutationKey = ['createRecordingDownloadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRecordingDownloadURL>>, {recordingId: string}> = (props) => {
          const {recordingId} = props ?? {};

          return  createRecordingDownloadURL(recordingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRecordingDownloadURLMutationResult = NonNullable<Awaited<ReturnType<typeof createRecordingDownloadURL>>>

    export type CreateRecordingDownloadURLMutationError = UnauthorizedResponse | Problem | NotFoundResponse | ConflictResponse

    /**
 * @summary Emite URL assinada para download da gravacao
 */
export const useCreateRecordingDownloadURL = <TError = UnauthorizedResponse | Problem | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRecordingDownloadURL>>, TError,{recordingId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRecordingDownloadURL>>,
        TError,
        {recordingId: string},
        TContext
      > => {
      return useMutation(getCreateRecordingDownloadURLMutationOptions(options), queryClient);
    }
